module.exports = __webpack_public_path__ + "static/award9-284be826af83b4c36790bb014a350acf.png";